// src/components/common/PageLoaderIndicator/PageLoaderIndicator.jsx
import React from 'react';
import { usePageLoader } from '../../../contexts/PageLoaderContext';
import styles from './PageLoaderIndicator.module.css'; // Можно переиспользовать или создать новые

const PageLoaderIndicator = () => {
    const { isLoading, message } = usePageLoader();

    if (!isLoading) {
        return null; // Если не загрузка, ничего не рендерим
    }

    return (
        <div className={styles.overlay} role="status" aria-live="assertive">
            <div className={styles.spinnerContainer}>
                <div className={styles.spinner}></div>
                {message && <p className={styles.loadingMessage}>{message}</p>}
            </div>
        </div>
    );
};

export default PageLoaderIndicator;
